<template>
  <tr>
    <!-- title -->
    <td>
      <router-link class="color-default" :to="'/categories/' + category.slug + '/posts'">
        {{ category.title }}
      </router-link>
    </td>

    <td>
      <span v-if="category.parent_category">
        {{ category.parent_category.title }}
      </span>
      <span v-else> - </span>
    </td>

    <!-- moderator -->
    <!-- <td v-if="moderator === 'unknown'"><span class="badge badge-danger">{{ moderator }}</span></td>
    <td v-else>
      <router-link :to="'/users/' + moderator.slug + '/posts'">{{ moderator.user_name }}</router-link>
    </td> -->

    <td>{{ category.total_posts }}</td>

    <!-- controls [update, delete] -->
    <td>
      <div class="btn-group">
        <a class="btn dropdown-toggle" data-toggle="dropdown" href="#">
          <span class="fas fa-ellipsis-v"></span>
        </a>
        <ul class="dropdown-menu">
         <router-link class="dropdown-item" :to="'/categories/' + category.slug + '/posts'">
       View
      </router-link>
          <a class="dropdown-item" @click="updateCategory">Update</a>
          <a class="dropdown-item text-danger" @click="deleteCategory">Delete</a>
        </ul>
      </div>
    </td>
    <!--<td>-->
    <!--<div class="btn-group btn-group-sm">-->
    <!--<button-->
    <!--v-if="$gate.allow('update', 'category', category)"-->
    <!--@click="updateCategory"-->
    <!--type="button"-->
    <!--class="btn btn-success"-->
    <!--&gt;Update</button>-->

    <!--<button-->
    <!--v-if="$gate.allow('delete', 'category')"-->
    <!--@click="deleteCategory"-->
    <!--type="button"-->
    <!--class="btn btn-danger"-->
    <!--&gt;Delete</button>-->
    <!--</div>-->
    <!--</td>-->
  </tr>
</template>

<script>
  import categoryForm from "./form";

  export default {
    props: ["category"],

    computed: {
      moderator: function () {
        if (typeof this.category.moderator === "undefined") {
          return "unknown";
        }
        return this.category.moderator;
      },

      description: function () {
        if (typeof this.category.description === "undefined") {
          return "";
        }
        let desc = this.category.description;
        if (desc.length > 100) {
          return desc.slice(0, 97) + "...";
        }
        return desc;
      },
    },

    methods: {
      updateCategory() {
        this.$store.dispatch("modal/update", {
          action: "update",
          formData: this.category,
          title: this.category.title,
          component: categoryForm,
        });
      },

      deleteCategory() {
        this.$store.dispatch("message/update", {
          title: this.category.title,
          body: "Are you sure you want to delete this Category?",
          class: "danger",
          confirm: true,
        });

        this.$bus.$off("proceed");
        this.$bus.$once("proceed", () => {
          this.delete(this.category);
          this.$store.dispatch("message/close");
        });
      },

      delete(category) {
        this.$store
          .dispatch("categories/deleteCategory", category)
          .then((response) => {
            this.$toast.success(response.data.message);
          })
          .catch((error) => {
            let response = error.response;
            this.$toast.error(response.data.message, {
              timeout: 50000,
            });
          });
      },
    },
  };
</script>

<!-- <style scoped>
  table tr td:nth-child(1) {
    width: 50% !important;
  }

  table tr td:nth-child(2) {
    width: 20% !important;
  }

  table tr td:nth-child(3) {
    width: 15% !important;
    text-align: center;

  }

  table tr td:nth-child(4) {
    width: 15% !important;
    text-align: center;
  }
</style> -->